import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext({ user: undefined, login: async () => {}, logout: async () => {} });

export function AuthProvider({ children }) {
  // undefined = checking; null = unauthenticated; obj = authenticated
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        if (!cancelled) setUser(data);
      } catch {
        if (!cancelled) setUser(null);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      // Logout call failed (network or session already expired). Don't block
      // the user — just record it for diagnostics and clear local state.
      console.warn("admin logout request failed:", err?.message || err);
    }
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}
